import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import './assets/css/base.scss';
import '@/assets/iconfont/iconfont.css'

const app = createApp(App).use(router)

import ElementPlus from 'element-plus' 
app.use(ElementPlus)


app.mount('#app')
// export default defineComponent({
//     components: {
//       NButton
//     }
//   })